import React from "react";
import {Mail, Phone} from "lucide-react";

const LawFirmHero = () => {
    return (<div className=" container mx-auto my-12 ">
            <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="our-red-bg text-white p-8 md:p-12 flex flex-col justify-between ">
                    <div className="max-w-md mx-auto ">
                        <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-6">
                            Défendre vos droits, c’est notre priorité.
                        </h1>

                        <p className="mb-8 text-sm md:text-base opacity-90">
                            Chez MesProcédures.fr, nous sommes à vos côtés pour résoudre efficacement vos problèmes
                            juridiques liés au <b>titre de séjour</b>, à<b> la naturalisation</b> ou à toute démarche
                            auprès de
                            <b> la préfecture</b>.
                        </p>
                        <p className="mb-8 text-sm md:text-base opacity-90">

                            Grâce à notre réseau <b>d’avocats spécialisés</b>, vous bénéficiez d’un accompagnement sur
                            mesure,
                            à chaque étape de vos procédures. Ensemble, nous faisons avancer votre dossier – même en
                            cas
                            de blocage – avec professionnalisme, réactivité et au <b>meilleur prix du marché</b>.
                        </p>

                        <div className="mt-12">
                            <div className="mb-2">
                                <svg className="h-12 w-32" viewBox="0 0 120 40">
                                    <path
                                        d="M10,20 C20,10 30,30 40,15 C50,5 60,25 70,20 C80,15 90,10 110,20"
                                        stroke="white"
                                        fill="none"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>

                            <h3 className="text-xl font-bold">Mes Procédures</h3>
                            <p className="text-sm opacity-90">
                                Vos procédures simplifiées, votre avenir assuré !
                            </p>
                        </div>
                    </div>
                </div>

                {/* Right image section */}
                <div
                    className="bg-gray-800 h-full"
                    style={{
                        backgroundImage: "url('/assets/img/theme/lawyer-xx.jpg')",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                >
                    <div
                        className="h-full w-full flex items-center justify-center "
                        style={{backgroundColor: "rgba(50, 58, 67, 0.8)"}}
                    >
                        <div className="mx-6 w-[90%] py-12">
                            <div className="border-1 border-dashed border-gray-400/30 p-8 text-white">
                                <h3 className="mb-3 text-2xl font-semibold">
                                    Besoin de nous ?
                                </h3>

                                <p className="mb-8 text-sm text-gray-300">
                                    Si vous avez besoin d'aide, n'hésitez pas à nous contacter.
                                </p>

                                <div className="space-y-4">
                                    <div className="flex items-center gap-3">
                                        <Phone className="h-5 w-5 text-red-600"/>
                                        <a href={"tel:+33189715961"} className="text-sm">
                                            +33 1 89 71 59 61
                                        </a>
                                    </div>

                                    <div className="flex items-center gap-3">
                                        <Mail className="h-5 w-5 text-red-600"/>
                                        <a
                                            href={"mailto:contact@mesprocedures.fr"}
                                            className="text-sm"
                                        >
                                            contact@mesprocedures.fr
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LawFirmHero;
